/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Happy_Agent_Earthworm_BoilInputs */

const fr_happy_agent_earthworm_boil = /** @type {(inputs: Happy_Agent_Earthworm_BoilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couleur personnalisée`)
};

/**

* @param {Happy_Agent_Earthworm_BoilInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const happy_agent_earthworm_boil = /** @type {((inputs?: Happy_Agent_Earthworm_BoilInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Happy_Agent_Earthworm_BoilInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_happy_agent_earthworm_boil(inputs)
});